<template>
    <div>
        <Form  @submit.native.prevent="preventSubmit" :model="editAccount" ref="editAccountForm" :rules="editAccount.rules" style="width:1500px;">
          <FormItem prop="account" label="账号" :label-width="70">
            <span>{{editAccount.account}}</span>
          </FormItem>
          <FormItem prop="createDate" label="建立时间" :label-width="80">
            <span>{{createDate}}</span>
          </FormItem>
          <FormItem prop="userName" label="用户名" :label-width="80">
            <Input type="text" v-model="editAccount.userName"></Input>
          </FormItem>
          <FormItem prop="bankName" label="银行名" :label-width="80">
            <Input type="text" :maxlength="32" v-model="editAccount.bankName"></Input>
          </FormItem>
          <FormItem prop="bankBranchName" label="支行名" :label-width="80">
            <Input type="text" v-model="editAccount.bankBranchName"></Input>
          </FormItem>
          <FormItem prop="bankNo" label="卡号" :label-width="80">
            <Input type="text" :maxlength="32" v-model="editAccount.bankNo"></Input>
          </FormItem>
          <FormItem prop="provinceId" label="登记省" :label-width="80">
            <Select v-model="editAccount.provinceId" ref="province" @on-change="changeProvice" filterable style="width:1200px;">
              <Option v-for="item in privoicesList" :value="item.id" :key="item.id">{{ item.custName }}</Option>
            </Select>
          </FormItem>
          <FormItem prop="cityId" label="登记市" :label-width="80">
            <Select v-model="editAccount.cityId" ref="city" @on-change="changeCity" filterable style="width:1200px;">
              <Option v-for="item in cityList" :value="item.id" :key="item.id">{{ item.custName }}</Option>
            </Select>
          </FormItem>
          <FormItem prop="districtId" label="登记区" :label-width="80">
            <Select v-model="editAccount.districtId" ref="district" filterable style="width:1200px;">
              <Option v-for="item in districtList" :value="item.id" :key="item.id">{{ item.custName }}</Option>
            </Select>
          </FormItem>
          <!-- <FormItem prop="hotspotId" label="所属热点" :label-width="80">
            <Select v-model="editAccount.hotspotId" ref="hotspot" filterable>
              <Option v-for="item in hotspotList" :value="item.id" :key="item.id">{{ item.hotspotName }}</Option>
            </Select>
          </FormItem> -->
          <FormItem prop="deposit" label="押金" :label-width="80">
              <Input type="text" :maxlength="11" v-model="editAccount.deposit"></Input>
          </FormItem>
          <!-- <FormItem prop="cardId" label="身份证号" :label-width="80">
              <Input type="text" v-model="editAccount.cardId"></Input>
            </FormItem> -->
          <!-- <FormItem prop="isAuth" label="身份验证" :label-width="80">
              <Select ref="queryParamsCity" v-model="editAccount.isAuth" style="width:150px;">
                <Option :value="1">已验证</Option>
                <Option :value="0">未验证</Option>                    
              </Select>
          </FormItem> -->
          <FormItem prop="isAgree" label="协议" :label-width="80">
              <Select ref="queryParamsCity" v-model="editAccount.isAgree" style="width:150px;">
                <Option :value="1">已签订</Option>
                <Option :value="0">未签订</Option>                    
              </Select>
          </FormItem>
          <FormItem label="所属企业" :label-width="80">
              <span>{{editAccount.landlordName}}</span>
              <Button type="primary" @click="selectEnterprise">{{!editAccount.landlordName ? '选择企业' : '更换企业' }}</Button>                
          </FormItem>
          <FormItem prop="isAuth" label="用户角色" :label-width="80">
            <Select ref="queryParamsCity" v-model="editAccount.role" style="width:150px;">
              <Option value="未开通">未开通</Option>
              <Option value="普通管家">普通管家</Option>
              <Option value="值班管家">值班管家</Option>
            </Select>
            <!-- <span>{{editAccount.role}}</span> -->
          </FormItem>
          <FormItem prop="remark" label="备注" :label-width="80">
              <Input type="text" :maxlength="200" v-model="editAccount.remark"></Input>
          </FormItem>
          <FormItem :label-width="80">
            <Button type="primary" @click="saveInfo">保存</Button>                
          </FormItem>
        </Form>
      <!-- 选择企业弹窗 -->
        <Modal title="选择企业" v-model="selectEnterpriseModal.display" :width="1000" :loading="true" ref="selectHouseKeeperModal">
          <Form @submit.native.prevent="preventSubmit" inline>
            <FormItem prop="name" label="ID：" :label-width="80">
              <Input type="text" v-model="sendEnterpriseParams.id" :maxlength="100"></Input>
            </FormItem>
            <FormItem prop="name" label="企业名称：" :label-width="120">
              <Input type="text" v-model="sendEnterpriseParams.name" :maxlength="100"></Input>
            </FormItem>
            <FormItem prop="name" label="手机号码：" :label-width="120">
              <Input type="text" v-model="sendEnterpriseParams.mobile" :maxlength="100"></Input>
            </FormItem>
            <FormItem style="margin-left:45px;">
              <Button type="primary" @click="queryEnterpriseListWithKeyword">查询</Button>
            </FormItem>
          </Form>
          <Content>
            <Table :columns="enterpriseColumns" :data="enterpriseList"></Table>
            <Page show-sizer :current="queryEnterpriseParams.page" :total="enterprisetotal" :page-size="queryEnterpriseParams.size" @on-change="enterpriseChangePage" @on-page-size-change="enterpriseChangePageSize"></Page>
          </Content>
          <div slot="footer">
            <Button type="default" size="large" @click="cancelModal({type:'cancelBtn'})">取消</Button>
          </div>
        </Modal>
    </div>
</template>

<script>
import Utils from '../../../utils'
import {integerRegExp } from "@/utils/regular"
import API from "../../../api";
import Moment from "moment"

export default {
     created() {
        this.cleanerId = Utils.getUrlParameterByName('id')
        this.token = Utils.findFromLocalStorage("vue-token");
        this.username = Utils.findFromLocalStorage("vue-username");
        this.env = Utils.findFromLocalStorage("env", "dev");
    },
    async mounted () {
        await this.queryCleanerInfo()
        await this.queryProvincesList()
        this.queryHotspotList()
        this.queryLandlordList()
        this.changeProvice(this.editAccount.provinceId)
        this.changeCity(this.editAccount.cityId)
        this.$Notice.config({
            top: 200
        })
    },
    computed:{
        createDate : function(){
            let createDate = Moment(this.editAccount.createDate).format('YYYY-MM-DD HH:mm');            
            return createDate
        }
    },
    data(){
        const accountRules = {
            userName: (rule, value, callback) => {
                if (this.editAccount.userName.length === 0) {
                    return callback(new Error('用户名不能为空'))
                }
                callback()
            },
            bankName: (rule, value, callback) => {
                if (this.editAccount.bankName.length === 0) {
                    return callback(new Error('银行名不能为空'))
                }
                callback()
            },
            bankBranchName: (rule, value, callback) => {
                if (this.editAccount.bankBranchName.length === 0) {
                    return callback(new Error('支行名不能为空'))
                }
                callback()
            },
            bankNo: (rule, value, callback) => {
                if (this.editAccount.bankNo.length === 0) {
                    return callback(new Error('卡号不能为空'))
                }
                callback()
            },
            provinceId: (rule, value, callback) => {
                if (!this.editAccount.provinceId) {
                    return callback(new Error('登记省不能为空'))
                }
                callback()
            },
            cityId: (rule, value, callback) => {
                if (!this.editAccount.cityId) {
                    return callback(new Error('登记市不能为空'))
                }
                callback()
            },
            districtId: (rule, value, callback) => {
                if (!this.editAccount.districtId) {
                    return callback(new Error('登记区不能为空'))
                }
                callback()
            },
            deposit: (rule, value, callback) => {
                if (!integerRegExp.test(this.editAccount.deposit)) {
                    return callback(new Error('格式不正确'))
                }
                callback()
            },
            // cardId: (rule, value, callback) => {
            //     if (!idNoRegular.test(this.editAccount.cardId)) {
            //         return callback(new Error('身份证填写不正确'))
            //     }
            //     callback()
            // },
            // isAuth: (rule, value, callback) => {
            //     if (!this.editAccount.isAuth && this.editAccount.isAuth !== 0) {
            //         return callback(new Error('身份验证不能为空'))
            //     }
            //     callback()
            // },
        }
        return {
            cleanerId:null,
            privoicesList:[],
            cityList:[],
            districtList:[],
            hotspotList:[],
            editAccount:{
                account:'',
                createDate:'',
                userName:'',
                bankName:'',
                bankBranchName:'',
                bankNo:'',
                provinceId:'',
                cityId:'',
                districtId:'',
                hotspotId:'',
                deposit:'',
                // cardId:'',
                // isAuth:0,
                role:'',//用户角色
                isAgree:0,
                landlordName:'',
                remark:'',
                rules:{
                    userName: [{required: true, trigger: 'blur', validator: accountRules.userName}],
                    bankName:[{required: true, trigger: 'blur', validator: accountRules.bankName}],
                    bankBranchName:[{required: true, trigger: 'blur', validator: accountRules.bankBranchName}],
                    bankNo:[{required: true, trigger: 'blur', validator: accountRules.bankNo}],
                    provinceId:[{required: true, trigger: 'change', validator: accountRules.provinceId}],
                    cityId:[{required: true, trigger: 'change', validator: accountRules.cityId}],     
                    districtId:[{required: true, trigger: 'change', validator: accountRules.districtId}],                  
                    deposit:[{required: true, trigger: 'blur', validator: accountRules.deposit}],
                    // cardId:[{required: true, trigger: 'blur', validator: accountRules.cardId}],
                    // isAuth:[{required: true, trigger: 'change', validator: accountRules.isAuth}],                    
                    }
            },
            selectEnterpriseModal:{
                display:false
            },
            enterpriseList:[],
            enterprisetotal:0,
            sendEnterpriseParams:{
                page:1,
                size:10,
                id:'',
                name:'',
                mobile:'',
                createDateEnd:'',
                createDateStart:'',
                examineState:'',
                lastLoginEnd:'',
                lastLoginStart:'',
                source:'',
            },
            queryEnterpriseParams:{
                page:1,
                size:10,
                id:'',
                name:'',
                mobile:'',
                createDateEnd:'',
                createDateStart:'',
                examineState:'',
                lastLoginEnd:'',
                lastLoginStart:'',
                source:'',
            },
            enterpriseColumns:[
                 {
                title: 'ID',
                align: 'center',
                key: 'id'
                },
                {
                title: '企业名称',
                align: 'center',
                key: 'realName'
                },
                {
                title: '手机号码',
                align: 'center',
                key: 'mobile'
                },
                {
                title: '选择',
                width: 200,
                align: 'center',
                render: (h, params) => {
                    return h('div', [
                    h(
                        'Button',
                        {
                        props: {
                            size: 'small',
                            type: 'warning'
                        },
                        on: {
                            click: () => {
                            this.cancelModal({
                                enterpriseInfo: params.row})
                            }
                        }
                        },
                        '选中'
                    )
                    ])
                 }
              }
            ]
        }
    },
    methods:{
        async queryCleanerInfo () {
            // return new Promise (async resolve => {
            //      let resp = (await API.omsAPI[this.env].cleaner.queryCleanerInfo({id:this.cleanerId},this.token)).data
            //      this.editAccount = Object.assign({},this.editAccount,resp)
            //     resolve()
            // })
          let resp = (await API.omsAPI[this.env].cleaner.queryCleanerInfo({id:this.cleanerId},this.token)).data
          this.editAccount = Object.assign({},this.editAccount,resp)
          this.editAccount.deposit = (resp.deposit)/100;
        },
        async queryProvincesList() { //获取省份列表
            // return new Promise (async resolve => {
            //     let ProvincesList = (await API.omsAPI[this.env].common.queryProvinces()).data
            //     this.privoicesList = ProvincesList.province || [];
            //     resolve()
            // })
            let ProvincesList = (await API.omsAPI[this.env].common.queryProvinces()).data
            this.privoicesList = ProvincesList.province || [];
        },
        async changeProvice (id) {
            let resp = (await API.omsAPI[this.env].common.queryCities(id)).data
            this.cityList = resp.city
        },
        async changeCity (id) {
            if (!id) {
                this.editAccount.districtId = null
            }
            let resp = (await API.omsAPI[this.env].common.queryCounties(id)).data            
            this.districtList = resp.county
        },
        async queryHotspotList () {
            let resp = (await API.omsAPI[this.env].cleaner.queryCleanerHotspotList({cityName:''},this.token))
            this.hotspotList = resp.data.data || [];
        },
        async queryLandlordList () {
            let resp = (await API.omsAPI[this.env].cleaner.queryLandlordList(this.queryEnterpriseParams,this.token)).data          
            this.enterprisetotal = resp.totalCount                             
            this.enterpriseList = resp.content || []
        },
        // 选择企业弹窗操作
        selectEnterprise () {
            this.selectEnterpriseModal.display = true
        },
        queryEnterpriseListWithKeyword () {
            this.queryEnterpriseParams = Object.assign({}, this.sendEnterpriseParams);
            this.queryLandlordList()
        },
        enterpriseChangePage (pageIndex) {
          this.listPage = pageIndex;
          this.queryEnterpriseParams.page = pageIndex
          this.queryLandlordList()
        },
        enterpriseChangePageSize (pageSize) {
            this.queryEnterpriseParams.size = pageSize
            this.queryLandlordList()
        },
        cancelModal (enterpriseInfo = {}) {
            if (enterpriseInfo.type !== 'cancelBtn') {
                this.editAccount.landlordId = enterpriseInfo.enterpriseInfo.id
                this.editAccount.landlordName = enterpriseInfo.enterpriseInfo.realName 
            }
            this.selectEnterpriseModal.display = false
        },
        async saveInfo () {
            let validResult = false
            this.$refs.editAccountForm.validate((valid) => {
                 validResult = valid
            })
            if (!validResult) {
                return
            }
            // if (!this.editAccount.landlordId) {
            //     this.$Notice.error({
            //         title:'请选择所属企业'
            //     })
            //     return 
            // }
            let params = {
                    id:this.cleanerId,
                    bankBranchName:this.editAccount.bankBranchName,
                    bankName:this.editAccount.bankName,
                    bankNo:this.editAccount.bankNo,
                    // cardId:this.editAccount.cardId,
                    role:this.editAccount.role,
                    city:this.$refs.city.query,
                    cityId:this.editAccount.cityId,
                    deposit:(this.editAccount.deposit)*100 || 0,
                    district:this.$refs.district.query,
                    districtId:this.editAccount.districtId,
                    // hotspotId:this.editAccount.hotspotId || '',
                    // hotspotName:this.$refs.hotspot.query || '',
                    landlordId:this.editAccount.landlordId || '' ,
                    landlordName:this.editAccount.landlordName || '',                    
                    isAgree:this.editAccount.isAgree,
                    // isAuth:this.editAccount.isAuth,
                    province:this.$refs.province.query,
                    provinceId:this.editAccount.provinceId,
                    remark:this.editAccount.remark || '',
                    updateName:this.username,
                    userName:this.editAccount.userName,
            }
            let resp = (await API.omsAPI[this.env].cleaner.editCleanerList(params,this.token)).data
            if (resp.retCode) {
                this.$Notice.error({
                    title: resp.msg
                })
            } else {
                this.$Notice.success({
                    title: '保存成功'
                })
            }                     
        },
        preventSubmit() {
            return false;
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/pages/cleaner/housekeeper-account-edit/account-edit.vue